import { VerificationDepositStatus } from "../status-cards/status-item/VerificationDepositStatus";

export const VerificationDepositConfig = {
  statusComponent: VerificationDepositStatus,
};
